module.exports = require('text!edge/endorsement/common/views/contact-agent.html')